import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/bond-ladder-calculator',
  component: () => import('../../routes/BondLadderCalculator.svelte'),
  card: {
    id: 'bond-ladder-calculator',
    title: 'Bond Ladder Calculator',
    description: 'Build a portfolio of bonds with staggered maturity dates. See annual coupon income, yield to maturity, and reinvestment earnings across your ladder.',
    icon: 'account_balance',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/bond-ladder-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Bond Ladder Calculator – Staggered Bond Portfolio Income Builder',
    description: 'Free bond ladder calculator to build a staggered bond portfolio. Enter your total investment, number of rungs, and maturity range to see annual coupon income, yield to maturity, and reinvestment earnings across all bonds.',
  },
};

export default meta;
